import React from 'react'
import { modalStyles } from '../ModalStyles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { DivPaperStyled, ModalStyled, Title } from '../Modals.styled';
import { Backdrop, Fade } from '@mui/material';
import { KTSVG } from '../../../_metronic/helpers';

const VendorRequestCreatedModal = ({open, setOpen, vendorRequestNumber}) => {
    const classes = modalStyles({});
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <DivPaperStyled className={classes.paper}>
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="col-12 d-flex btn btn-icon btn-sm btn-active-light-primary" onClick={() => setOpen(false)}>
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                    </div>
                        <>
                            <div className="row justify-content-center">
                                <div className="col-12 d-flex justify-content-center">
                                    <KTSVG path='/media/icons/bootstrap/check-circle.svg' className='svg-icon svg-icon-3x text-success'/>
                                </div>
                                <div className="col-12 mt-5">
                                    <Title style={{marginBottom: 0}}>Thank you for submitting the quote request.</Title>
                                    <Title style={{marginBottom: 0}}>You will be contacted shortly by our staff.</Title>
                                    <Title>Your reference number for this quote is #{vendorRequestNumber}</Title>
                                </div>
                            </div>
                            <div className="row mt-1 mb-3">
                                <div className="col-12 d-flex justify-content-center">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setOpen(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </>
                </DivPaperStyled>
            </Fade>
        </ModalStyled>
    )
}

export default VendorRequestCreatedModal